module.exports = __webpack_public_path__ + "static/008235-3c87348e757d5ea33b83a82b85323814.jpg";